import React, { useState, useRef } from 'react';
import { RefreshCw, Download, Check, AlertCircle } from 'lucide-react';
import { isTauri, relaunchApp } from '../utils/tauri';

type CheckState = 'idle' | 'checking' | 'available' | 'downloading' | 'upToDate' | 'error';

export const ManualUpdateCheck: React.FC = () => {
  const [state, setState] = useState<CheckState>('idle');
  const [version, setVersion] = useState('');
  const updateRef = useRef<any>(null);

  const handleCheck = async () => {
    try {
      setState('checking');
      const { check } = await import('@tauri-apps/plugin-updater');
      const update = await check();
      if (update) {
        updateRef.current = update;
        setVersion(update.version);
        setState('available');
      } else {
        setState('upToDate');
      }
    } catch {
      setState('error');
    }
  };

  const handleInstall = async () => {
    if (!updateRef.current) return;
    try {
      setState('downloading');
      await updateRef.current.downloadAndInstall();
      await relaunchApp();
    } catch {
      setState('error');
    }
  };

  if (!isTauri()) return null;

  return (
    <div className="flex items-center justify-between py-3">
      <div>
        <p className="text-sm text-slate-800">앱 업데이트</p>
        <p className="text-xs text-slate-500">
          {state === 'checking' && '확인 중...'}
          {state === 'upToDate' && '최신 버전입니다'}
          {state === 'available' && `v${version} 업데이트 가능`}
          {state === 'downloading' && '설치 중...'}
          {state === 'error' && '업데이트 확인 실패'}
          {state === 'idle' && '새로운 업데이트를 확인합니다'}
        </p>
      </div>
      {(state === 'idle' || state === 'upToDate' || state === 'error') && (
        <button
          onClick={handleCheck}
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-700 bg-slate-100 hover:bg-slate-200 border border-slate-200 rounded-lg transition-colors"
        >
          {state === 'upToDate' ? <Check size={14} /> : <RefreshCw size={14} />}
          업데이트 확인
        </button>
      )}
      {state === 'checking' && (
        <RefreshCw size={16} className="text-slate-400 animate-spin" />
      )}
      {state === 'available' && (
        <button
          onClick={handleInstall}
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-white bg-brand-600 hover:bg-brand-700 rounded-lg transition-colors"
        >
          <Download size={14} />
          v{version} 설치
        </button>
      )}
      {state === 'downloading' && (
        <RefreshCw size={16} className="text-brand-600 animate-spin" />
      )}
    </div>
  );
};
